module.exports = "<p>\n  shared works!\n</p>\n"